if (!customElements.get('details-modal')) {
  customElements.define('details-modal', class extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');
      this.detailsContainer.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      const closeBtn = this.querySelector('button[type="button"]');
      if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));
    }
    isOpen() {
      return this.detailsContainer.hasAttribute('open');
    }
    onSummaryClick(event) {
      event.preventDefault();
      this.isOpen() ? this.close() : this.open(event);
    }
    onBodyClick(event) {
      if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
    }
    open(event) {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      this.detailsContainer.setAttribute('open', true);
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');
      const input = this.detailsContainer.querySelector('input:not([type="hidden"])');
      if (input) setTimeout(() => input.focus(), 100);
    }
    close() {
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
    }
  });
}
